import React, { forwardRef } from 'react'

import { useFormContext, useController } from 'react-hook-form'

import DollarInput from 'modules/ui/molecules/DollarInput'
import { mergeRefs } from '../utils'

export type DollarInputFieldProps = {
  id: string | number
  label: string
  error?: { message: string }
  required?: boolean
  dataId?: string
  autoFocus?: boolean
  onFocus?: () => void
}

const DollarInputField = forwardRef<HTMLInputElement, DollarInputFieldProps>(
  ({ id, error, required, label, dataId = '', autoFocus, onFocus }, externalRef) => {
    const { control } = useFormContext()

    const { field, fieldState, formState } = useController({
      name: `${id}`,
      control,
      defaultValue: '0.00',
    })

    const { isDirty } = fieldState
    const { isSubmitted } = formState

    const ref = externalRef
      ? mergeRefs<HTMLInputElement>(
          externalRef as React.MutableRefObject<HTMLInputElement>,
          field.ref as unknown as React.MutableRefObject<HTMLInputElement>,
        )
      : field.ref

    return (
      <DollarInput
        {...field}
        id={`${id}`}
        error={(isDirty || isSubmitted) && error ? error.message : undefined}
        required={required}
        inputRef={ref}
        label={label}
        dataId={dataId}
        autoFocus={autoFocus}
        onFocus={onFocus}
      />
    )
  },
)

DollarInputField.displayName = 'DollarInputField'

export default DollarInputField
